//Replicate for stage and prod
export const environment = {
  production: false,
  environment: 'stage',
  title: 'Sierra Finance',
  name: 'sierra-finance',
  asset: {
    stationAssetTypeReference: '67abfb9aee06eac3505f9834',
  },
  /**
   * Deploy-time feature switches (#5166). Off here means the control is not rendered at all; the API gates
   * the same capability independently, so flipping this on without the matching server flag surfaces a
   * control whose calls are refused.
   */
  features: {
    /** Lets a clerk mark an AP document as requiring a Constancia regardless of its line classifications. */
    forcedWithholding: true,
  },

  proxyUrls: {
    assetApi: 'https://asset.api.stage.sierra-erp.com',
    itemApi: 'https://item.api.stage.sierra-erp.com',
    userMasterApi: 'https://user.api.stage.sierra-erp.com',
    productionApi: 'https://production.api.stage.sierra-erp.com',
    inventoryApi: 'https://inventory.api.stage.sierra-erp.com',
    orderApi: 'https://order.api.stage.sierra-erp.com',
    financeApi: 'https://finance.api.stage.sierra-erp.com',
  },
  domainUrl: {
    order: 'https://www.order-stage.sierra-erp.com',
  },
};
